export default () => {
  const data = {
    event_name: 'click',
    button_name: 'banner_homer_find',
    page_section: 'banner_homer_find',
    name_of_the_page_viewed: 'development_list_personal',
  };
  return data;
};
